const ArrowDownIcon = props => (
  <svg
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_892_19960"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="-1"
      width="14"
      height="15"
    >
      <rect
        y="14"
        width="14.0002"
        height="14.0002"
        transform="rotate(-90 0 14)"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_892_19960)">
      <path
        d="M12.632 4.66664L7.00059 10.2981L1.36914 4.66664L2.19705 3.83873L7.00059 8.64242L11.8041 3.83873L12.632 4.66664Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default ArrowDownIcon;
